import { render, staticRenderFns } from "./ServerDown.vue?vue&type=template&id=4e33b093&scoped=true"
import script from "./ServerDown.vue?vue&type=script&lang=js"
export * from "./ServerDown.vue?vue&type=script&lang=js"
import style0 from "./ServerDown.vue?vue&type=style&index=0&id=4e33b093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e33b093",
  null
  
)

export default component.exports